"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.getDataConnectorsValues = exports.getDataConnectors = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = exports.fields = ['question', 'description', 'visualType', 'label', 'isCheckedByDefault', 'isCheckNecessary', 'noCheckMessage', 'isSettingsExpanded', 'isValidationExpanded'];
var ttsFields = exports.ttsFields = function ttsFields(_ref) {
  var settings = _ref.settings,
    isMatrixMode = _ref.isMatrixMode;
  return isMatrixMode ? [] : ['question', 'description', 'label'];
};
var initialValues = exports.initialValues = {
  question: '<p><strong>Do you agree to the terms and conditions?</strong></p>',
  visualType: 'checkbox',
  label: 'I agree',
  isSettingsExpanded: true,
  noCheckMessage: 'You have to agree'
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-check"
});
var validate = exports.validate = function validate(values) {
  return {};
};
var getMetricsPrefix = exports.getMetricsPrefix = function getMetricsPrefix() {
  return 'cb';
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  var prefix = getMetricsPrefix();
  var data = {
    title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
    titleHtml: settings.question,
    "enum": [0, 1],
    enumDisplayText: ['unchecked', 'checked'],
    questionType: 'checkbox',
    reportHeader: "".concat(prefix, "_").concat(id),
    variableType: 'answer',
    tags: {
      system: ['answer']
    }
  };
  return _defineProperty({}, id + '_answer', _objectSpread({}, data));
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  if (answer === undefined) {
    return _defineProperty({}, id + '_answer', null);
  }
  return _defineProperty({}, id + '_answer', answer ? 1 : 0);
};
var getDataConnectors = exports.getDataConnectors = function getDataConnectors(settings) {
  var connectors = {
    number: {
      type: 'number',
      title: 'Result: 1 = Checked, 0 = Unchecked'
    }
  };
  return connectors;
};
var getDataConnectorsValues = exports.getDataConnectorsValues = function getDataConnectorsValues(settings, answer) {
  return {
    number: function number() {
      return answer ? 1 : 0;
    }
  };
};